import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import sorro from "../../assets/image/stella/sorro.png";

const faqData = [
    {
        id: 1,
        question: "¿Cómo actualizar Stella TV?",
        answer: "Tienes dos opciones para actualizar Stella TV: la primera es descargar la última versión desde este sitio web; la otra es directamente desde la app, que te notificará cuando haya una nueva versión disponible."
    },
    {
        id: 2,
        question: "Stella TV no funciona ¿qué hago?",
        answer: "Si encuentras errores en los canales, te recomendamos reportarlo. Si un canal se vuelve lento o presenta lag, verifica tu conexión a internet o intenta cerrar y volver a abrir la app."
    },
    {
        id: 3,
        question: "¿Cómo me registro en Stella TV app?",
        answer: "No es posible registrarse directamente en la app. Para iniciar sesión con una cuenta de Stella TV, necesitas comprar una cuenta o solicitar un demo, ya que estos son los únicos métodos para obtener acceso."
    },
    {
        id: 4,
        question: "¿Cuántas versiones hay de StellaTV?",
        answer: "Actualmente, ofrecemos dos versiones de Stella TV: una para celulares y otra para smart TVs, TV Box y Firestick. Además, se puede instalar en una PC con Windows o macOS mediante emuladores de Android como Nox Player o BlueStacks."
    },
    {
        id: 5,
        question: "¿Cómo descargar Stella TV para iPhone?",
        answer: "Stella TV no está disponible para iPhone; esta aplicación solo es compatible con dispositivos que utilizan el sistema operativo Android, como celulares, tabletas, smart TVs, TV Box, Fire Stick, Google Chromecast o Google TV."
    }
];

const AccordionItem = ({ i, expanded, setExpanded, question, answer }) => {
    const isOpen = i === expanded;

    return (
        <motion.div
            initial={false}
            className="mb-4 overflow-hidden rounded-lg bg-white  shadow-sm"
        >
            {/* Cabecera (Pregunta) */}
            <motion.header
                initial={false}
                onClick={() => setExpanded(isOpen ? false : i)}
                className={`flex cursor-pointer items-center text-black justify-between p-6 transition-colors duration-300 ${
                    isOpen
                        ? "bg-gradient-to-r from-orange-500 to-red-600 text-white" // Estilo Activo (Naranja)
                        : " text-gray-900 hover:bg-gray-50" // Estilo Inactivo (Blanco)
                }`}
            >
                <h3 className={`text-lg font-bold sm:text-xl font-sans ${
                    isOpen
                        ? "text-white" // Estilo Activo (Naranja)
                        : " text-gray-900 hover:text-[#eeb500]" // Estilo Inactivo (Blanco)
                }`} >{question}</h3>

                {/* Icono de flecha animado */}
                <motion.div
                    animate={{ rotate: isOpen ? 180 : 0 }}
                    transition={{ duration: 0.3 }}
                >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                </motion.div>
            </motion.header>

            {/* Cuerpo (Respuesta) con Framer Motion */}
            <AnimatePresence initial={false}>
                {isOpen && (
                    <motion.section
                        key="content"
                        initial="collapsed"
                        animate="open"
                        exit="collapsed"
                        variants={{
                            open: { opacity: 1, height: "auto" },
                            collapsed: { opacity: 0, height: 0 }
                        }}
                        transition={{ duration: 0.3, ease: [0.04, 0.62, 0.23, 0.98] }}
                    >
                        <div className="border-t border-gray-100 bg-white p-6 text-gray-700 leading-relaxed">
                            {answer}
                        </div>
                    </motion.section>
                )}
            </AnimatePresence>
        </motion.div>
    );
};

// 3. Componente Principal de la Sección
export default function Question() {
    const [expanded, setExpanded] = useState(0);

    return (
        <div className="min-h-screen bg-[#111] px-6 py-20 text-white font-sans">
            <div className="mx-auto max-w-7xl">
                <div className="grid gap-12 lg:grid-cols-2 lg:gap-8">

                    {/* Columna Izquierda: Textos e Imagen */}
                    <div className="flex flex-col justify-start">
                        <span className="mb-2 text-yellow-500 font-bold uppercase tracking-wider">FAQ</span>
                        <h2 className="mb-6 text-5xl font-extrabold leading-tight uppercase">
                            Preguntas <br /> Frecuentes
                        </h2>
                        <p className="mb-8 text-gray-400 max-w-md text-lg">
                            Aquí encontrarás respuestas a las preguntas frecuentes sobre cómo <span className="text-white font-semibold">  descargar e instalar Stella TV Global </span>en diversos dispositivos.
                        </p>
                        <p className="mb-12 text-gray-400 text-lg">
                            Esperamos responder a todas ellas.
                        </p>

                        {/* Aquí va tu imagen del zorro */}
                        <div className="relative mt-auto w-full max-w-xs mx-auto lg:mx-0">
                            {/* Reemplaza src con tu importación real */}
                            <img
                                src={sorro}
                                alt="Mascota pensando"
                                className="w-full object-contain drop-shadow-2xl"
                            />
                        </div>
                    </div>

                    {/* Columna Derecha: Acordeón */}
                    <div className="flex flex-col justify-center">
                        {faqData.map((item) => (
                            <AccordionItem
                                key={item.id}
                                i={item.id}
                                expanded={expanded}
                                setExpanded={setExpanded}
                                question={item.question}
                                answer={item.answer}
                            />
                        ))}

                    </div>


                </div>
            </div>
        </div>
    );
}